import { getErrorMessage } from '@/api/core/axiosErrorMapper';
import { useClearFinishedTasks, useMyTasks } from '../core/_hooks';
import { isRunning } from '../core/_utils';
import TaskRow from './TaskRow';

/** Aba Tarefas do menu de notificações: o que roda, o que terminou e o que falhou. */
const TaskTabPanel = () => {
  const { data: tasks = [], isPending, isError, error } = useMyTasks();
  const clearFinished = useClearFinishedTasks();
  const running = tasks.filter(isRunning).length;

  return (
    <div aria-labelledby="notifications-tab-tasks" id="notifications-panel-tasks" role="tabpanel">
      <div className="d-flex align-items-center justify-content-between px-6 py-4 border-bottom bg-light-secondary">
        <span className="text-muted fw-semibold fs-7">{running} em andamento</span>
        <button
          className="btn btn-sm btn-secondary fw-bold"
          disabled={running === tasks.length || clearFinished.isPending}
          type="button"
          onClick={() => clearFinished.mutate()}
        >
          Limpar finalizadas
        </button>
      </div>
      <div className="scroll-y mh-325px py-2">
        {isError ? <div className="alert alert-danger mx-6 my-4">{getErrorMessage(error)}</div> : null}
        {!isError && !isPending && tasks.length === 0 ? (
          <div className="text-center py-10">
            <i className="bi bi-inboxes fs-3x text-gray-400 d-block mb-3" />
            <div className="fw-bold text-gray-700">Nenhuma tarefa por aqui</div>
            <div className="fs-7 text-gray-500">Exportações aparecem aqui enquanto rodam.</div>
          </div>
        ) : null}
        <div aria-label="Tarefas" role="list">
          {tasks.map((task) => (
            <TaskRow key={task.name} task={task} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TaskTabPanel;
